module.exports = __webpack_public_path__ + "img/deviation.22981a44.svg";